export const WEATHER_API_KEY = '474337f982cee7ee6a536a6623d97a57';
export const SFDATA_API_KEY = 'TmnsQZtPesideUfTbGU3BeaAV';
export const THUNDERFOREST_API_KEY = 'f4dc8cfedad640a9978deb1172fc1fdc';
export const JAWG_API_KEY = 'T8fRFm0lod3N8oLv5G0zR9MXxvraC2YorDBt2hGXMAA0UwIPGaCrqumLPBvel61k';
